export default () => ({
  appName: import.meta.env.VITE_APP_NAME || "UnifiK",
  apiUrl: import.meta.env.VITE_API_URL || "http://localhost:3000",
  contactEmail: import.meta.env.VITE_CONTACT_EMAIL || "contacto@wmpartner.cl",
  mapboxToken: import.meta.env.VITE_MAPBOX_TOKEN || "",
});
